export default "__VITE_ASSET__Q1D3NRqR__"